import axios from "../../config/axiosConfig";

export default class BlogService {
  getAllBlog = async () => {
    try {
      const response = axios.get("blogs");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la contact : " + error.message
      );
    }
  };
  getAllBlogActive = async () => {
    try {
      const response = axios.get("blogs/blogs/active");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la contact : " + error.message
      );
    }
  };
  getAllBlogActiveHumanis = async () => {
    try {
      const response = axios.get("blogs/blogs/humanis");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la contact : " + error.message
      );
    }
  };
  createBlog = async (data) => {
    try {
      const response = axios.post("/blogs", data);
      return response.data;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la mission : " + error.message
      );
    }
  };
  toggleRStatus = async (id, data) => {
    try {
      const response = axios.put(`/blogs/${id}/toggle`, data);
      return response.data;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la mission : " + error.message
      );
    }
  };
  getBlogById = async (id) => {
    try {
      const response = axios.get(`/blogs/${id}`);
      return response;
    } catch (error) {
      throw new Error("Erreur  : " + error.message);
    }
  };
  updateBlog = async (id, data) => {
    try {
      const response = axios.put(`/blogs/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(
        "Erreur lors de l' edit de la mission : " + error.message
      );
    }
  };
}
